
import {
  Component, Mixins, Prop,
} from 'vue-property-decorator';
import { HistoryItemType, HistoryPackageItem } from '@/features/shipment-history/types';
import TrackingNumber from '@/features/shipment-history/components/tableColumns/TrackingNumber.vue';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component({
  components: {
    TrackingNumber,
  },
})
export default class Created extends Mixins(ResponsivenessMixin) {
  @Prop({ required: true }) item!: HistoryItemType;

  @Prop({ required: true }) visiblePackages!: HistoryPackageItem[];

  @Prop({ required: true }) invisiblePackages!: HistoryPackageItem[];

  @Prop({ required: true }) packagesExpanded!: boolean;

  @Prop({ default: [] }) visibleStatuses!: string[];

  @Prop({ default: [] }) invisibleStatuses!: string[];

  get isMoreThan5(): boolean {
    return this.item.packages.length > 5;
  }

  get expandBtnText(): string {
    return this.packagesExpanded
      ? this.$t('buttons.less') as string
      : this.$t('buttons.showMore', { amount: this.invisiblePackages.length }) as string;
  }

  private handleTrackingNumberClick(packageItem: HistoryPackageItem): void {
    this.$emit('openDetails', 'tracking', packageItem.carrierTrackingNumber);
  }
}
